<c-autoform-select options="$ctrl.options" selected-option="$ctrl.selected" editable="$ctrl.editable"></c-autoform-select>

